import Translator from 'translator';
import { Map } from 'immutable';
import { SvgHome, SvgBox, SvgCraftsman, SvgProduct, SvgTicket, SvgUser } from 'data/common/iconsvg';
import BookmarkIcon from '@material-ui/icons/Bookmark';

export default new Map({
    homesList: {
        key: 0,
        label: Translator.translate('general.Homes'),
        path: 'home',
        right: 'homeList',
        Icon: SvgHome
    },
    usersList: {
        key: 1,
        label: Translator.translate('general.Users'),
        path: 'users',
        right: 'usersList',
        Icon: SvgUser
    },
    boxesList: {
        key: 2,
        label: Translator.translate('fhe.centerName'),
        path: 'box',
        right: 'boxList_fhe',
        Icon: SvgBox
    },
    brandsList: {
        key: 3,
        label: Translator.translate('general.brands'),
        path: 'brands',
        right: 'brandsList',
        Icon: BookmarkIcon,
    },
    /*installersList: {
        key: 3,
        label: Translator.translate('general.installers'),
        path: 'installer',
        right: 'installerList',
        Icon: SvgCraftsman
    },*/
    productsList: {
        key: 4,
        label: Translator.translate('general.Products'),
        path: 'products',
        right: 'productsList',
        Icon: SvgProduct
    },
    notificationList: {
        key: 5,
        label: Translator.translate('general.Notifications'),
        path: 'notifications',
        right: 'notificationList',
        Icon: SvgTicket
    },
    ticketsgitsList: {
        key: 6,
        label: Translator.translate('general.ticketsgit'),
        path: 'issues',
        right: 'issuesList',
        Icon: SvgTicket
    },
    pushNotificationList: {
        key: 7,
        label: Translator.translate('general.PushNotification'),
        path: 'push-notifications',
        right: 'pushNotificationList',
        Icon: SvgTicket
    }
});



// WEBPACK FOOTER //
// ./environments/fhe/common/subMenuData.js